import { createContext } from 'react';
import GlobalContextI from '../interfaces/GlobalContext';

const GlobalContext: GlobalContextI | null = createContext<null>(
    null
) as GlobalContextI;

export default GlobalContext as GlobalContextI;
